import { render } from "./UiCard.vue?vue&type=template&id=62a8a3f8"
import script from "./UiCard.vue?vue&type=script&lang=js"
export * from "./UiCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__